// client/src/components/order/ReorderButton.js
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { RefreshCw } from 'lucide-react';
import toast from 'react-hot-toast';
import ReorderModal from './ReorderModal';
import { ordersAPI } from '../../services/api';

const ReorderButton = ({ order, onReorderSuccess }) => {
  const { t } = useTranslation('business');
  const [showModal, setShowModal] = useState(false);
  const [reorderData, setReorderData] = useState(null);
  const [loading, setLoading] = useState(false);

  // Check if order can be reordered
  const canReorder = ['delivered', 'confirmed', 'processing', 'shipped'].includes(order.status);
  
  if (!canReorder) {
    return null;
  }

  const handleReorderClick = async (e) => {
    e.stopPropagation();
    
    try {
      setLoading(true);
      const encodedOrderId = encodeURIComponent(order._id);
      const response = await ordersAPI.getReorderPreview(encodedOrderId);
      
      console.log('🔵 Full response:', JSON.stringify(response.data, null, 2));
      console.log('🔵 Response has items?', 'items' in response.data);
      console.log('🔵 Response has availableItems?', 'availableItems' in response.data);
      console.log('🔵 Response keys:', Object.keys(response.data));
      
      if (response.data.reorderSummary.canReorder) {
        setReorderData(response.data);
        setShowModal(true);
      } else {
        toast.error(t('reorder.cannotReorder'));
      }
    } catch (error) {
      console.error('❌ Failed to get reorder preview:', error);
      toast.error(t('reorder.failedToPrepareReorder') + ': ' + (error.response?.data?.message || error.message));
    } finally {
      setLoading(false);
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setReorderData(null);
  };

  return (
    <>
      <button
        onClick={handleReorderClick}
        disabled={loading}
        className="inline-flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        title={t('reorder.reorderWithSameItems')}
      >
        <RefreshCw className={`w-4 h-4 ${loading ? 'animate-spin' : ''}`} />
        {loading ? t('reorder.loading') : t('reorder.reorderButton')}
      </button>

      {showModal && reorderData && (
        <ReorderModal
          isOpen={showModal}
          onClose={handleCloseModal}
          reorderData={reorderData}
          originalOrder={order}
        />
      )}
    </>
  );
};

export default ReorderButton;